import { LEG_KINDS } from "./constants";
import type { CableTypeShare, CableTypesOfCircuit } from "./types";

// One line per cable, not per leg: two legs on the same type are one length of that type.
export const cableTypesOfCircuit: CableTypesOfCircuit = ({ legs, circuitType, legTypes = {} }) => {
  const shares = new Map<string, CableTypeShare>();
  LEG_KINDS.forEach((kind) => {
    const metres = legs[kind];
    if (!metres) return;
    const cableType = legTypes[kind] || circuitType;
    const share = shares.get(cableType) ?? { cableType, totalM: 0, kinds: [] };
    share.totalM += metres.totalM;
    share.kinds.push(kind);
    shares.set(cableType, share);
  });
  return [...shares.values()].sort((a, b) => b.totalM - a.totalM);
};
